/**
 * Generates a self-contained React component (.jsx file string) for the current chart.
 * All theme values, colors, and data are inlined as constants.
 * The exported component accepts optional width/height props.
 */

import { computeData, themeSnap } from './shared';
import { genBar } from './genBar';
import { genScatter } from './genScatter';
import { genLine } from './genLine';
import { genBoxPlot } from './genBoxPlot';
import { genHistogram } from './genHistogram';
import { genLollipop } from './genLollipop';
import { genDivergingBar } from './genDivergingBar';
import { genHeatmap } from './genHeatmap';
import { genCombo } from './genCombo';
import { genRadar } from './genRadar';

/**
 * Returns a .jsx file string for the current chart, or null if unsupported.
 */
export function generateReactComponent(chartType, config, theme, isLoaded, rawData, mapping) {
  const data = computeData(chartType, config, isLoaded, rawData, mapping);
  const t = themeSnap(theme);

  const withSvgFont = (source) =>
    source.replaceAll(
      '<svg width={width} height={height}>',
      "<svg width={width} height={height} style={{ fontFamily: THEME.fontLabel || THEME.fontBody }}>"
    );

  switch (chartType.category) {
    case 'bar':          return withSvgFont(genBar(chartType, config, t, data));
    case 'scatter':      return withSvgFont(genScatter(chartType, config, t, data));
    case 'line':         return withSvgFont(genLine(chartType, config, t, data));
    case 'distribution': return withSvgFont(genBoxPlot(chartType, config, t, data));
    case 'histogram':    return withSvgFont(genHistogram(chartType, config, t, data));
    case 'lollipop':     return withSvgFont(genLollipop(chartType, config, t, data));
    case 'diverging-bar': return withSvgFont(genDivergingBar(chartType, config, t, data));
    case 'heatmap':      return withSvgFont(genHeatmap(chartType, config, t, data));
    case 'combo':        return withSvgFont(genCombo(chartType, config, t, data));
    case 'radar':        return withSvgFont(genRadar(chartType, config, t, data));
    default:             return null;
  }
}
